import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportChangeInnerTabPayload } from '../types';
import {
  REPORT_ADD_INNER_TAB_API_URL,
  REPORT_CHANGE_INNER_TAB_MUTATION,
  REPORT_REMOVE_INNER_TAB_API_URL,
} from '../constants';

export default function useReportChangeInnerTabMutation(): IContextMutationResult<void, Error, IReportChangeInnerTabPayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IReportChangeInnerTabPayload>({
    mutationKey: [REPORT_CHANGE_INNER_TAB_MUTATION],
    mutationFn: ({
      options: {
        reportType,
        widgetType,
        permission,
      },
      add,
      tabId,
      innerTabId,
      ...payload
    }) => fetchPut<void>(
      add ? REPORT_ADD_INNER_TAB_API_URL : REPORT_REMOVE_INNER_TAB_API_URL,
      payload,
      {
        permission,
        urlParams: {
          reportType,
          widgetType,
          tabId,
          innerTabId,
        },
      },
    ),
  });
}
